import React, { useEffect, useState } from 'react'
import { thumbUrl } from '../utils/photoThumb'

interface ListPhotoProps {
  /** 원본 사진 주소. 작은 복사본 주소는 여기서 만든다 */
  src: string
  alt: string
  className?: string
  draggable?: boolean
}

/**
 * 목록에 쓰는 사진.
 *
 * 작은 복사본을 먼저 쓰고, 없으면 원본으로 물러난다.
 *
 * 왜 물러나야 하는가
 * -----------------
 * 썸네일 주소는 원본 주소에서 규칙으로 만든다 — 파일이 실제로 있는지는
 * 확인하지 않는다. 사진마다 S3에 물어보면 피드 한 페이지에 수십 번
 * 왕복하게 되기 때문이다. 그래서 아직 만들어지지 않은 사진은 404가 나고,
 * 그때 원본으로 바꿔 단다. 썸네일이 없다고 사진이 안 보이면 안 된다.
 *
 * 사진 상세(전체 화면)에서는 쓰지 말 것 — 거기는 확대까지 되므로 원본이어야 한다.
 */
const ListPhoto: React.FC<ListPhotoProps> = ({
  src,
  alt,
  className,
  draggable,
}) => {
  const [useOriginal, setUseOriginal] = useState(false)

  // 사진이 바뀌면(목록 재사용) 다시 썸네일부터 시도한다
  useEffect(() => {
    setUseOriginal(false)
  }, [src])

  const shown = useOriginal ? src : thumbUrl(src)

  return (
    <img
      src={shown}
      alt={alt}
      className={className}
      draggable={draggable}
      onError={() => {
        // 원본까지 실패하면 더 할 게 없다. 무한 반복을 막는다.
        if (!useOriginal) setUseOriginal(true)
      }}
    />
  )
}

export default ListPhoto
